import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, FieldArray } from 'redux-form';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import AsyncSelect from 'react-select/lib/Async';
import renderTasks from './EventTask';

class EscalationForm extends React.Component {
  constructor() {
    super();

    this.state = {
      primary: {},
      selectedOption: 'N',
      showResolutionScore: false
    };
  }

  componentDidMount() {
    //const initialValues = this.props;
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          maxLength={maxLength}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Issue Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onTypeChange = (val) => {
    this.props.change('issueType', val);
  }

  renderSelect1 = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" value={this.state.selectedOption}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect2 = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control">
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTextarea = ({
    input,
    label,
    type,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          rows="5"
          placeholder={label}
          type={type}
          className={`form-control`}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          // dateFormat="YYYY-MM-DD"
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : moment().format('MM/DD/YYYY');
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
              // input.onChange(param)
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderUsersSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type User Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onUserChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onUserChange = (val) => {
    this.props.change('assignedTo', val);
  }

  searchUsers = (search) => {
    return this.props.searchUsers(search, 'isActive');
  }

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Type Client Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('client', val);
  }

  searchClients = (search) => {
    return this.props.searchClients(search, 'isActive');
  }

  renderLocationsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchLocations}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Type Location Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onLocationChange = (val) => {
    this.props.change('location', val);
  }

  searchLocations = (search) => {
    return this.props.searchLocations(search, 'isActive');
  }

  renderPatientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchPatients}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type Patient Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onPatientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onPatientChange = (val) => {
    this.props.change('patient', val);
  }

  searchPatients = (search) => {
    return this.props.searchPatients(search, 'isActive');
  }

  onChange = (e, val) => {
    this.setState({ selectedOption: val });
    if (val === 'Y') {
      this.setState({ showResolutionScore: true });
    }
    else {
      this.setState({ showResolutionScore: false });
    }
  }

  renderAssignmentSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type User Name..."
          menuPlacement="top"
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99,
              color: '#108ee9',
            }),
          }}
          onChange={this.onAssignmentChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onAssignmentChange = (val) => {
    this.props.change('taskAssignedTo', val);
  }

  renderToggler = props => (
    <div className={`form-group`}>
      <label className="col-md-2 text-right">{props.label}</label>
      <div className="col-md-10">
        <input type="checkbox" {...props.input} />
      </div>
    </div>
  );

  render() {
    const {
      searchClients,
      searchPatients,
      handleSubmit,
      initialValues,
      pristine,
      submitting,
    } = this.props;

    const showResolutionScore = initialValues.resolved === 'Y';

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Escalation</legend>
          <div className="alert alert-warning fade in">
            <p>
              “WARNING: Escalation information is not private and can be shared internally amongst staff. Please be courteous, considerate, cautious and professional
              when referencing any individual (co-worker, patient, client or other) as part of this escalation.”
            </p>
          </div>
          <br />
          <Field
            className="form-control"
            name="dateReported"
            component={this.renderDateField}
            type="text"
            placeholder="DateReported"
            label="Date Reported"
          />
          <Field
            className="form-control"
            name="issueName"
            component={this.renderField}
            type="text"
            placeholder="IssueName"
            label="Issue Name"
          />
          <Field
            name="issueType"
            component={this.renderTypesSelect}
            label="Issue Type"
          />
          <Field
            className="form-control"
            name="importance"
            component={this.renderSelect2}
            type="text"
            label="Importance"
          >
            <option value="-1">Select</option>
            <option value="1">Very Low</option>
            <option value="2">Low</option>
            <option value="3">Medium</option>
            <option value="4">High</option>
            <option value="5">Highest</option>
          </Field>
          <Field
            name="assignedTo"
            component={this.renderUsersSelect}
            label="Assigned To"
          />
          <Field
            name="location"
            component={this.renderLocationsSelect}
            label="Location"
          />
          {searchClients &&
            <Field
              name="client"
              component={this.renderClientsSelect}
              label="Client"
            />
          }
          {searchPatients &&
            <Field
              name="anonymous"
              className="form-control"
              component={this.renderToggler}
              type="checkbox"
              label="Anonymous"
            />
          }
          {searchPatients &&
            <Field
              name="patient"
              component={this.renderPatientsSelect}
              label="Patient"
            />
          }
          <Field
            className="form-control"
            name="description"
            component={this.renderTextarea}
            type="text"
            placeholder="Description"
            label="Description"
          />
          <Field
            className="form-control"
            name="resolved"
            component={this.renderSelect1}
            type="text"
            label="Resolved"
            onChange={this.onChange}
          >
            <option value="-1">Select</option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </Field>
          {(showResolutionScore || this.state.showResolutionScore) &&
            <Field
              className="form-control"
              name="resolutionScore"
              component={this.renderSelect2}
              type="text"
              label="Resolution Score"
            >
              <option value="-1">Select</option>
              <option value="1">1 - Very Unsatisfied</option>
              <option value="2">2 - Unsatisfied</option>
              <option value="3">3 - OK</option>
              <option value="4">4 - Satisfied</option>
              <option value="5">5 - Very Satisfied</option>
            </Field>
          }
          <Field
            className="form-control"
            name="createdByName"
            component={this.renderField}
            type="text"
            placeholder="CreatedByName"
            label="CreatedByName"
            disabled={true}
          />
          <Field
            className="form-control"
            name="createdAt"
            component={this.renderField}
            placeholder="CreatedAt"
            label="CreatedAt"
            disabled={true}
          />
        </fieldset>
        <fieldset>
          <legend>Tasks</legend>
          <FieldArray
            name="tasks"
            component={renderTasks}
            props={{ searchUsers: this.searchUsers }}
          />
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting || this.props.isExecutive}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div >
      </form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.issueType) {
    errors.issueType = 'Required';
  }
  if (!values.issueName) {
    errors.issueName = 'Required';
  }
  if (!values.assignedTo) {
    errors.assignedTo = 'Required';
  }
  if (values.task) {
    errors.dueDate = 'Required';
    errors.taskAssignedTo = 'Required';
  }
  if (!values.patient) {
    errors.patient = 'Required';
  }
  if (!values.location) {
    errors.location = 'Required';
  }
  if (values.dueDate) {
    errors.dueDate = '';
  }
  if (values.anonymous === true) {
    errors.patient = '';
  }
  if (values.taskAssignedTo) {
    errors.taskAssignedTo = '';
  }
  return errors;
};

EscalationForm = connect(state => ({
  formValues: getFormValues('escalation')(state),
  initialValues: state.escalationmanager.escalation,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'escalation' })(EscalationForm));
export default EscalationForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/EscalationForm.js